import { render, staticRenderFns } from "./SetZoneTable.vue?vue&type=template&id=5a775854&scoped=true"
import script from "./SetZoneTable.vue?vue&type=script&lang=js"
export * from "./SetZoneTable.vue?vue&type=script&lang=js"
import style0 from "./SetZoneTable.vue?vue&type=style&index=0&id=5a775854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a775854",
  null
  
)

export default component.exports